import { useState } from "react";

/**
 * Convert a Google Drive share URL into a hotlink-friendly image URL.
 * Supports:
 *   https://drive.google.com/file/d/<ID>/view?usp=sharing
 *   https://drive.google.com/open?id=<ID>
 *   https://drive.google.com/uc?export=view&id=<ID>
 * Returns the original URL unchanged if it is not a Drive link.
 */
function normalizeImageUrl(raw) {
  if (!raw) return raw;
  const url = raw.trim();
  if (!url.includes("drive.google.com")) return url;

  let id = null;
  const m1 = url.match(/\/file\/d\/([^/]+)/);
  if (m1) id = m1[1];
  if (!id) {
    const m2 = url.match(/[?&]id=([^&]+)/);
    if (m2) id = m2[1];
  }
  if (!id) return url;
  return `https://lh3.googleusercontent.com/d/${id}=w1920?authuser=0`;
}

/**
 * Image URL input with live preview + Google Drive auto-conversion.
 */
export default function ImageUploader({ value, onChange }) {
  const [broken, setBroken] = useState(false);

  const handleChange = (e) => {
    setBroken(false);
    const normalized = normalizeImageUrl(e.target.value);
    onChange(normalized);
  };

  return (
    <div>
      <input
        type="url"
        className="form-control"
        value={value || ""}
        onChange={handleChange}
        placeholder="https://... (วาง URL รูปภาพ)"
      />
      <div className="form-text">
        รองรับ Google Drive (แค่วางลิงก์แชร์ปกติ ระบบจะแปลงให้อัตโนมัติ),
        Imgur, Cloudinary และ URL รูปภาพสาธารณะอื่น ๆ
      </div>
      {value && (
        <div className="mt-2">
          {broken ? (
            <div className="alert alert-warning py-2 small mb-0">
              โหลดรูปไม่สำเร็จ — ตรวจสอบว่า:
              <ol className="mb-0 mt-1">
                <li>ไฟล์ถูกตั้งแชร์เป็น "ทุกคนที่มีลิงก์"</li>
                <li>URL ถูกต้อง</li>
              </ol>
            </div>
          ) : (
            <img
              src={value}
              alt="preview"
              onError={() => setBroken(true)}
              style={{ maxWidth: 240, maxHeight: 160, objectFit: "cover" }}
              className="rounded border"
            />
          )}
        </div>
      )}
    </div>
  );
}
